import React, { forwardRef } from 'react';
import { Modal, Box } from '@mui/material';

const DSModal = forwardRef<HTMLDivElement, React.ComponentProps<typeof Modal>>(
  (props, ref) => {
    const { children, ...modalProps } = props;

    return (
      <Modal {...modalProps}>
        <Box
          ref={ref}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '24px',
            background: '#383838',
            boxShadow:
              '0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 11px 15px -7px rgba(0, 0, 0, 0.20)',
            outline: 'none',
            maxHeight: '90vh',
            maxWidth: '90vw',
            overflow: 'auto',
          }}
        >
          {children}
        </Box>
      </Modal>
    );
  },
);

export default DSModal;
